import React, { useState, useEffect } from 'react';

const font = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";

const C = {
  blue:    '#1a56db',
  white:   '#ffffff',
  bg:      '#f0f2f5',
  gray2:   '#f3f4f6',
  gray3:   '#e5e7eb',
  gray4:   '#9ca3af',
  gray5:   '#6b7280',
  gray6:   '#374151',
  gray7:   '#111827',
  green:   '#16a34a',
  greenBg: '#dcfce7',
  purple:  '#7c3aed',
  purpleBg:'#ede9fe',
};

export default function VersionPage() {
  const [versions, setVersions] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    fetch('/api/version')
      .then(r => r.json())
      .then(d => { setVersions(d.versions || []); setLoading(false); })
      .catch(() => { setError('Could not load version info.'); setLoading(false); });
  }, []);

  const latest = versions[0];

  return (
    <div style={{
      minHeight: '100vh', background: C.bg,
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
      padding: '40px 20px', fontFamily: font,
    }}>
      <div style={{ maxWidth: 580, width: '100%' }}>

        {/* Header */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: C.blue, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>
            MessageBeacon
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: C.gray7, margin: 0, marginBottom: 6 }}>
            What's new
          </h1>
          {latest && (
            <div style={{ fontSize: 14, color: C.gray5 }}>
              Current version: <strong style={{ color: C.gray7 }}>{latest.version}</strong>
              <span style={{ marginLeft: 8, fontSize: 12, color: C.gray4 }}>· {latest.date}</span>
            </div>
          )}
        </div>

        {loading && (
          <div style={{ fontSize: 13, color: C.gray4, padding: '20px 0' }}>Loading…</div>
        )}
        {error && (
          <div style={{ fontSize: 13, color: '#dc2626', padding: '12px 16px', background: '#fee2e2', borderRadius: 10 }}>{error}</div>
        )}

        {/* Version cards */}
        {versions.map((v, vi) => (
          <div key={v.version} style={{
            background: C.white, borderRadius: 16, padding: '24px 28px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.07)', marginBottom: 16,
            border: vi === 0 ? `1.5px solid ${C.blue}` : '1.5px solid transparent',
          }}>
            {/* Version header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.gray7 }}>{v.version}</div>
              {vi === 0 && (
                <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 99, background: C.blue, color: '#fff' }}>
                  Current
                </span>
              )}
              <div style={{ fontSize: 12, color: C.gray4, marginLeft: 'auto' }}>{v.date}</div>
            </div>

            {/* What's New */}
            {v.new.length > 0 && (
              <div style={{ marginBottom: v.fixed.length > 0 ? 18 : 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                  <div style={{ width: 20, height: 20, borderRadius: 6, background: C.purpleBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11 }}>✨</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: C.purple, textTransform: 'uppercase', letterSpacing: '0.06em' }}>What's New</div>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {v.new.map((item, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                      <div style={{ width: 5, height: 5, borderRadius: '50%', background: C.purple, flexShrink: 0, marginTop: 7 }} />
                      <span style={{ fontSize: 13, color: C.gray6, lineHeight: 1.5 }}>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Bugs Fixed */}
            {v.fixed.length > 0 && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                  <div style={{ width: 20, height: 20, borderRadius: 6, background: C.greenBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11 }}>🐛</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: C.green, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Bugs Fixed</div>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {v.fixed.map((item, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                      <div style={{ width: 5, height: 5, borderRadius: '50%', background: C.green, flexShrink: 0, marginTop: 7 }} />
                      <span style={{ fontSize: 13, color: C.gray6, lineHeight: 1.5 }}>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}

        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 12, color: C.gray4 }}>
          MessageBeacon · messagebeacon.uk
        </div>
      </div>
    </div>
  );
}
